module.exports = __webpack_public_path__ + "1c1b2ff0f2940ca43b98dff6c9128c16.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/img/logo.png
// module id = 500
// module chunks = 0